import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ICommandParameters } from "../../authentication/connection/iCommandParameters";
import { ICommandResponse } from "../../authentication/connection/iCommandResponse";
import { ClientRegistrationResponseDTO, ErrorDetails } from "../../authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";

export class GetClientCommand extends IRequestCommand<
  IGetClienResponse,
  ErrorDetails,
  IGetClientCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/{carrierUserId}/clients/{clientId}';

  public override setParameters(parameters: IGetClientCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierUserId}',
      parameters.carrierUserId
    );
    this._commandUrl = this._commandUrl.replace(
      '{clientId}',
      parameters.clientId
    );
  }
}

export interface IGetClientCommandParameters extends ICommandParameters {
  carrierUserId?: string;
  clientId?: string;
}

export interface IGetClienResponse
  extends ClientRegistrationResponseDTO,
    ICommandResponse {
  // phoneNumber?: string;
  // city?: string;
  // cc: number
  id?: number;
  firstName?: string;
  lastName?: string;
  dni?: string;
}
